// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"_2kNGa","icon":"_32paW","filename":"zb8pt"};